import {
  Component
} from '@angular/core';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/take';


export class SkyListViewChecklistDemoComponent {
  public items = Observable.of([
    { id: '1', column1: 101, column2: 'Apple', column3: 'Anne eats apples'},
    { id: '2', column1: 202, column2: 'Banana', column3: 'Ben eats bananas' },
    { id: '3', column1: 303, column2: 'Pear', column3: 'Patty eats pears' },
    { id: '4', column1: 404, column2: 'Grape', column3: 'George eats grapes' },
    { id: '5', column1: 505, column2: 'Banana', column3: 'Becky eats bananas' },
    { id: '6', column1: 606, column2: 'Lemon', column3: 'Larry eats lemons' },
    { id: '7', column1: 707, column2: 'Strawberry', column3: 'Sally eats strawberries' }
  ]);

  public selectedItems: any[] = [];
  public selectMode = 'multiple';

  public selectedItemsChange(selectedMap: Map<string, boolean>) {
    this.items.take(1).subscribe((items) => {
      this.selectedItems = items.filter((item) => {
        return selectedMap.get(item.id);
      });
    });
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-list-view-checklist-demo',
  template: `<div style="margin-bottom: 10px;">
  <h3>
    Selection mode
  </h3>
  <div>
    <sky-radio
      name="selectMode"
      [(ngModel)]="selectMode"
      value="multiple">
      <sky-radio-label>
        Default select mode
      </sky-radio-label>
    </sky-radio>
  </div>
  <div>
    <sky-radio
      name="selectMode"
      [(ngModel)]="selectMode"
      value="single">
      <sky-radio-label>
        Single select mode
      </sky-radio-label>
    </sky-radio>
  </div>
</div>

<sky-list
  [data]="items"
  (selectedIdsChange)="selectedItemsChange($event)">
  <sky-list-toolbar>
  </sky-list-toolbar>
  <sky-list-view-checklist
    label="column2"
    description="column3"
    [selectMode]="selectMode">
  </sky-list-view-checklist>
</sky-list>
<div>
  <label>Selected items:</label>
  <ul>
    <li *ngFor="let item of selectedItems">
      {{item.column2}}
    </li>
  </ul>
</div>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
